import {
  Disclaimer,
  lightTheme,
  OrderStatus,
  Pill,
  TooltipIcon,
} from '@vgrubs/components';

export const RenderStatus = (status: OrderStatus) => {
  switch (status) {
    case 'new':
      return {
        color: lightTheme.yellow,
        name: 'New',
      };

    case 'accepted':
      return {
        color: lightTheme.green,
        name: 'Accepted',
      };

    case 'cancelled':
      return {
        color: lightTheme.primary,
        name: 'Cancelled',
      };

    case 'completed':
      return {
        color: lightTheme.green,
        name: 'Completed',
      };

    default:
      break;
  }
};

export const OrdersStatusPill = ({
  status,
  rejectReason,
}: {
  status: OrderStatus;
  rejectReason: string;
}) => {
  return (
    <Pill $background={RenderStatus(status)?.color} $gap="4px">
      <Disclaimer $m="0" $color={lightTheme.white} $capitalize $semiBold>
        {RenderStatus(status)?.name}
      </Disclaimer>
      {rejectReason && status === OrderStatus.cancelled && (
        <TooltipIcon tooltip={rejectReason} color={lightTheme.white} />
      )}
    </Pill>
  );
};
